var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.aboutThePlatform))])])
}
var staticRenderFns = []

export { render, staticRenderFns }